import { GridUtils, Link } from '@atlassian/amkt-common';
import { LinkUtils } from '@atlassian/mpac-utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import CommonPropTypes from '../../../app/constants/PropTypes';
import Meta from '../Meta';
import {
  ErrorPage as ErrorPageStyled,
  ErrorPageImage,
  ErrorPageInner,
  GoBackLink,
  Heading,
  MoreInfo,
  Text,
} from './ErrorPage.styles';

export default class ErrorPage extends Component {
  static propTypes = {
    homeLink: CommonPropTypes.link.isRequired,
    heading: PropTypes.string.isRequired,
    primaryMessage: PropTypes.string.isRequired,
    history: CommonPropTypes.history,
    image: PropTypes.string.isRequired,
    statusCode: PropTypes.number.isRequired,
    supportMessage: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };

  UNSAFE_componentWillMount() {
    // SEO4Ajax sets onCaptureReady on window - when SEO4Ajax is rendering this error page, we can execute it
    // with a status code so that we can override the standard 200 with a more appropriate status code for it to cache
    // (or not cache, if a 5xx) and later return to bots
    if (window.onCaptureReady) {
      window.onCaptureReady(this.props.statusCode);
    }
  }

  onClickBack = event => {
    event.preventDefault();
    if (this.props.history) {
      this.props.history.goBack();
    } else {
      window.history.back();
    }
  };

  onSearchForApps = event => {
    if (this.props.history) {
      LinkUtils.maybeOpenInNewTab(event, () => {
        this.props.history.push({ pathname: this.props.homeLink.get('href') });
      });
    }
  };

  render() {
    return (
      <ScreenClassRender render={this.renderNotFound}>
        <span />
      </ScreenClassRender>
    );
  }

  renderNotFound = sc => {
    return (
      <ErrorPageStyled
        padding={GridUtils.triFoldScreenClass(sc)('50px 25px', '80px 40px', '100px 50px')}
      >
        <Meta title={this.props.title} />
        <ErrorPageInner>
          <ErrorPageImage src={this.props.image} alt="" />
          <Text>
            <Heading>{this.props.heading}</Heading>
            <MoreInfo>
              <span>
                {this.props.primaryMessage}. You can{' '}
                <GoBackLink onClick={this.onClickBack}>go back</GoBackLink>,{' '}
              </span>
              <Link href={this.props.homeLink.get('href')} onClick={this.onSearchForApps}>
                search for apps
              </Link>
              ,<span> or {this.props.supportMessage}, feel free to </span>
              <Link
                href="http://go.atlassian.com/marketplace-support"
                rel="noopener noreferrer"
                target="_blank"
              >
                contact our support team
              </Link>
              .
            </MoreInfo>
          </Text>
        </ErrorPageInner>
      </ErrorPageStyled>
    );
  };
}
